export const getUserVehicleId = ({ app }) => app.data.userdata.mygarage.activeVehicleDetails.vehicleId

export const getSelectedVehicle = ({ app }) =>
  app.data.userdata.mygarage.activeVehicleDetails

